<template>
    <div class="my-input">
        <div class="my-input-slot">
            <slot name="prepend"></slot>
        </div>
        <ux-input
            v-bind="$attrs" v-model="data" v-on="$listeners"
        ></ux-input>
        <div class="my-input-slot">
            <slot name="append"></slot>
        </div>
    </div>
</template>
<script>
export default {
  name: 'MyInput',
  model: {
    prop: 'value', // 要存在于props
    event: 'change' // 当组件的值发生改变时要emit的事件名
  },
  props: {
    value: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      data: this.value,
      oldData: this.value,
    };
  },
  watch: { // 这里检测data中的值，一旦发生变化就提交事件到父组件
    data: {
      handler(newVal) {
        this.$emit('change', newVal);
        this.$emit('input', newVal);
      },
      deep: true
    },
    value: {
      handler(newVal) {
        this.data = newVal;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.my-input {
    position: relative;
    width: 100%;
    height: 40px;
    background: $color-bg-disable;
    border-radius: 2px;
    display: flex;
    align-items: center;

    .my-input-slot {
        flex: 0 0 auto;
        color: $color-text-secondary;
    }

    ::v-deep .ux-input {
        height: 40px;

        .el-input__inner {
            background: $color-bg-disable;
            border-color: transparent !important;
        }

        .el-input__icon {
            background-color: transparent !important;
        }
    }
}


</style>
